import Axios from 'axios'
import DiffChecker from './../core/DiffChecker'
import MessageHelper from './../core/MessageHelper'
import { uuid } from './../core/Functions'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    globalServices: [],
    dataCenters: [],
    servers: [],
    watchedServers: [],
    notifications: []
  },

  getters: {
    getGlobalServices(state) {
      return state.globalServices;
    },
    getDataCenters(state) {
      return state.dataCenters;
    },
    getServers(state) {
      return state.servers;
    },
    getWatchedServers(state) {
      return state.watchedServers;
    },
    getNotifications(state) {
      return state.notifications;
    }
  },

  mutations: {
    setGlobalServices(state, payload) {
      state.globalServices = payload;
    },
    setDataCenters(state, payload) {
      state.dataCenters = payload;
    },
    setServers(state, payload) {
      state.servers = payload;
    },
    addWatchedServer(state, payload) {
      state.watchedServers.push(payload);
    },
    removeWatchedServer(state, payload) {
      state.watchedServers.splice(state.watchedServers.indexOf(payload), 1);
    },
    addNotification(state, payload) {
      state.notifications.push({
        id: uuid(),
        title: payload.title ? payload.title : 'Information',
        body: payload.body ? payload.body : '',
        timeout: payload.timeout ? payload.timeout : 3000,
        position: payload.position ? payload.position : 'top-right',
        sound: payload.sound ? payload.sound : null
      });
    },
    removeNotification(state, id) {
      let newArray = state.notifications;
      let index = state.notifications.map(notification => notification.id).indexOf(id)
      newArray.splice(index, 1);

      state.notifications = newArray;
    },
    clearNotificationQueue(state) {
      state.notifications = [];
    }
  },

  actions: {
    async fetchDataCenters(context) {
      await Axios.get(`${appConfig.apiUrl}/api/data-centers`, {
        headers: {'Authorization': "bearer " + ""}
      }).then(response => {
        response.data.sort((a, b) => a.name.localeCompare(b.name));
        context.commit('setDataCenters', response.data);
      }).catch(() => {
        context.commit('addNotification', {
          title: 'Error',
          body: 'There was an error fetching the data center information from the API.',
          sound: 'error'
        });
      });
    },
    async fetchServers(context) {
      await Axios.get(`${appConfig.apiUrl}/api/servers`, {
        headers: {'Authorization': "bearer " + ""}
      }).then(response => {
        response.data.sort((a, b) => a.name.localeCompare(b.name));
        
        let beforeUpdate = context.state.servers;
        context.state.globalServices.forEach(obj => beforeUpdate.push(obj));

        // Always check for changes before updating the state.
        context.dispatch('checkForServerChanges', {
          before: beforeUpdate,
          after: response.data
        });

        // Split the global servers away from the game servers.
        let globalServices = response.data.filter(server => server.name === 'Gate' || server.name === 'Login');
        let servers = response.data.filter(server => server.name != 'Gate' && server.name != 'Login')

        context.commit('setGlobalServices', globalServices);
        context.commit('setServers', servers);
      }).catch(() => {
        context.commit('addNotification', {
          title: 'Error',
          body: 'There was an error fetching the server information from the API.',
          sound: 'error'
        });
      });
    },
    toggleWatchedServer(context, payload) {
      if (context.state.watchedServers.includes(payload)) {
        context.commit('removeWatchedServer', payload);
      } else {
        // Check to see if the user wants to see desktop notifications as well.
        if (
          'Notification' in window &&
          'serviceWorker' in navigator &&
          Notification.permission !== 'denied' &&
          Notification.permission !== 'granted'
        ) {
          Notification.requestPermission().then(async permission => {
            if (permission === "granted") {
              try {
                let reg = await navigator.serviceWorker.ready

                reg.showNotification('XIVStatus', {
                  body: 'Desktop notifications have been enabled!'
                })
              } catch {
                /* eslint-disable-next-line */
                console.error('XIVStatus: There was an error enabling the desktop notifications.')
              }
            }
          });
        }

        context.commit('addWatchedServer', payload);
        context.commit('addNotification', {
          title: payload,
          body: `You are now watching for changes to ${payload}.`,
          timeout: 3000,
          sound: 'confirm'
        });
      }
    },
    checkForServerChanges(context, payload) {
      let before = payload.before;
      let after = payload.after;

      let changed = {};

      for (let i = 0; i < context.state.watchedServers.length; i++) {
        let serverName = context.state.watchedServers[i];
        let oldServers = before.filter((server => server.name === serverName));
        let newServers = after.filter((server => server.name === serverName));

        if (oldServers.length > 0 && newServers.length > 0) {
          changed[serverName] = DiffChecker.getObjectDiff(oldServers[0], newServers[0]);
        }
      }

      MessageHelper.emitServerChanges(changed);
    }
  }
});